/**
 * UWV-connector per werkgever (besluit 11) — API-client.
 * Backend: src/routes/uwvConnector.ts. Het geheim komt nooit terug; de client
 * ziet alleen of het is ingesteld.
 */
import api from './api';

const d = <T,>(r: { data: { data: T } }) => r.data.data;
const BASE = '/employer/uwv-connector';

export interface UwvConnectorInstellingen {
  mag_beheren: boolean;
  webhook_url?: string | null;
  geheim_ingesteld?: boolean;
  actief?: boolean;
  bijgewerkt_op?: string | null;
  platform_terugval?: boolean;
  koppeling_beschikbaar?: boolean;
  bron?: 'werkgever' | 'platform' | null;
}

export const getUwvConnector = () => api.get<{ data: UwvConnectorInstellingen }>(BASE).then(d);
export const slaUwvConnectorOp = (body: { webhook_url: string; geheim?: string | null; actief?: boolean }) =>
  api.put<{ data: UwvConnectorInstellingen }>(BASE, body).then(d);
export const verwijderUwvConnector = () => api.delete<{ data: UwvConnectorInstellingen }>(BASE).then(d);
